// extracted by mini-css-extract-plugin
module.exports = {"vertical-center":"style_vertical-center__1RL56","padding":"style_padding__3zzH-","logoCause":"style_logoCause__86CzZ"};